<template>
  <b-card id="airport-transfer-widget">
    <b-row class="mb-4">
      <b-col>
        <h4 class="text-uppercase fr-font-weight-super-bold fr-title-mobile-size fr-title-desktop-size text-center">
          {{ $t("pages.airportTransferService.bookingSelector.title") }}
        </h4>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col cols="12">
        <b-alert show variant="primary" class="small p-3">
          {{ $t('legal.thirdPartyTransferNotice') }}
          <a href="https://mallorcatransfers.online/aviso-legal.php" target="_blank" rel="noopener noreferrer" class="alert-link">
            {{ $t('legal.thirdPartyTransferPolicyLink') }}
          </a>
        </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <div class="iframe-center-container">
          <iframe id="mnt-iframe"
            :src="`https://mallorcatransfers.online/widget/?token=Y1nDSeB2sxx8DRfeb8td9milaw1ajRoz4QfgnHQit0WamygRb1gSAN9ce6JzDNQL&lang=${widgetLanguage}`"
            width="100%" height="850" scrolling="no" frameborder="0"></iframe>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BAlert } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale.substring(0, 2).toLowerCase();
    },
    widgetLanguage() {
      let lang;

      if (this.currentLanguage === 'ca') {
        lang = 'es';
      } else if (['en', 'es', 'de'].includes(this.currentLanguage)) {
        lang = this.currentLanguage;
      } else {
        lang = 'en';
      }

      return lang;
    }
  },
  mounted() {
    // Plain JavaScript logic to resize iframe based on its width
    function resizeIframe() {
      const iframe = document.getElementById('mnt-iframe');
      if (!iframe) return;
      const width = iframe.offsetWidth;
      if (width <= 399) {
        iframe.style.height = '890px';
      } else if (width > 399 && width <= 639) {
        iframe.style.height = '790px';
      } else if (width > 639) {
        iframe.style.height = '600px';
      }
    }
    window.addEventListener('load', resizeIframe);
    window.addEventListener('resize', resizeIframe);
    // Call once in case already loaded
    resizeIframe();
  },
  methods: {
  }
};
</script>

<style lang="scss">
.iframe-center-container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
</style>
